import { render, staticRenderFns } from "./ServerDataSelector.vue?vue&type=template&id=6fdda848&"
import script from "./ServerDataSelector.vue?vue&type=script&lang=js&"
export * from "./ServerDataSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports